import { autostoreBinMaintenanceApi } from "./autostoreBinMaintenance";

export const {
  useStartBinMaintenanceMutation,
  useConfirmInventoryMovementMutation,
  usePostSkipMaintenanceInventoryMovementMutation,
  useRequestNextMaintenanceBinMutation
} = autostoreBinMaintenanceApi.enhanceEndpoints({
  addTagTypes: [],
  endpoints: {}
});
